// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kKCUvBL0NSbkMZ {
  display: flex;
  align-items: center;
  height: 32px;
  margin: var(--ds-space-0, 0);
  padding: var(--ds-space-0, 0);
  border: 0;
  border-radius: var(--ds-border-radius-100, 3px);
  box-shadow: none;
  font-weight: var(--ds-font-weight-bold, bold);
  line-height: 32px;
  text-decoration: none;
  white-space: nowrap;
}
.kKCUvBL0NSbkMZ.U56D9_yAOl3HO_ {
  outline: var(--ds-border-focused, #388bff) auto 2px;
  outline-offset: 2px;
}
.mac .kKCUvBL0NSbkMZ.U56D9_yAOl3HO_ {
  outline-color: -webkit-focus-ring-color;
}
.kKCUvBL0NSbkMZ.U56D9_yAOl3HO_ .mac.firefox {
  outline-color: AccentColor;
}
.kKCUvBL0NSbkMZ._x7I6m9VsyvGU6 {
  background-color: var(--ds-background-danger-bold, #ca3521);
}
.kKCUvBL0NSbkMZ .yPWICtSVsDRjmX {
  padding: var(--ds-space-0, 0) var(--ds-space-150, 12px);
}
.kKCUvBL0NSbkMZ .ramuWxwtuWwnQt {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  margin: var(--ds-space-0, 0);
}
`, ""]);
// Exports
export var headerButton = `kKCUvBL0NSbkMZ`;
export var focusRing = `U56D9_yAOl3HO_`;
export var alert = `_x7I6m9VsyvGU6`;
export var buttonText = `yPWICtSVsDRjmX`;
export var headerButtonIcon = `ramuWxwtuWwnQt`;
export default ___CSS_LOADER_EXPORT___;
